import React, {useEffect, useState} from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import Chart from 'react-apexcharts';
import 'react-datepicker/dist/react-datepicker.css';
import ApiUtils from 'api/ApiUtils';

const ReportUserAnalyticsDemographics = ({dashBoardCount}: any): any => {
  // const [startDate, setStartDate] = useState(new Date());
  // const selectedYear = moment(startDate).format('YYYY');
  const [cardData, setCardData]: any = useState();
  console.log('🚀 ~ ReferralConversionRate ~ cardData:', cardData);

  // const [activeChart, setActiveChart] = useState<string>('');
  // const inputRef: any = useRef(null);
  // const inputRefByYear: any = useRef(null);

  const fetchDasboardData = async (): Promise<void> => {
    const resp: any = await ApiUtils.getNewRegisterVenuesData(2025);
    setCardData(resp?.data);
  };

  useEffect(() => {
    void fetchDasboardData();
  }, []);

  // const series = [
  //   {
  //     name: 'New Venue Registration',
  //     data: cardData?.map((data: any) => {
  //       return data.count;
  //     }),
  //   },
  //   // {
  //   //   name: 'Refunds',
  //   //   data: cardData?.refundChartOrder?.map((data: any) => {
  //   //     return data.count;
  //   //   }),
  //   // },
  //   // {
  //   //   name: 'Earnings',
  //   //   data: cardData?.earningChartOrer?.map((data: any) => {
  //   //     return data.count;
  //   //   }),
  //   // },
  // ];

  // const conversationRatio: any =
  //   (cardData?.TotalOrderChartCount /
  //     (cardData?.orderCount + cardData?.refundOrderprice)) *
  //     100 !==
  //     0 || 0;

  const optionsGenderBased: any = {
    chart: {
      height: 700,
      // type: 'donut',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Gender based ratio`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    legend: {
      position: 'bottom', // This places the legend at the bottom
      horizontalAlign: 'center', // Centers the legend items
      floating: false, // Set to false to avoid floating over the chart
    },
    // series: [
    //   dashBoardCount?.total_not_signed_venue,
    //   dashBoardCount?.total_pending_venue,
    //   dashBoardCount?.total_signed_venue,
    // ],
    labels: ['Male', 'Female'],
  };

  const optionsMemberBased: any = {
    chart: {
      height: 700,
      // type: 'donut',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    colors: ['#33FF57', '#FF5733'],
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Member based ratio`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    legend: {
      position: 'bottom', // This places the legend at the bottom
      horizontalAlign: 'center', // Centers the legend items
      floating: false, // Set to false to avoid floating over the chart
    },
    // series: [
    //   dashBoardCount?.total_not_signed_venue,
    //   dashBoardCount?.total_pending_venue,
    //   dashBoardCount?.total_signed_venue,
    // ],
    labels: ['Member', 'Non Member'],
  };

  // const optionsActiveInactive: any = {
  //   chart: {
  //     height: 400,
  //     type: 'donut',
  //     zoom: {
  //       enabled: false,
  //     },
  //     toolbar: {
  //       show: false,
  //     },
  //   },
  //   // dataLabels: {
  //   //   enabled: false,
  //   // },
  //   stroke: {
  //     curve: 'straight',
  //   },
  //   title: {
  //     text: `Active/In Active Users ${selectedYear}`,
  //     align: 'left',
  //   },
  //   grid: {
  //     row: {
  //       colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
  //       opacity: 0.5,
  //     },
  //   },
  //   series: [dashBoardCount?.active_user, dashBoardCount?.inactive_user],
  //   labels: ['Active', 'In Active'],
  // };

  // const onChangeChartPeriod = (pType: any): void => {
  //   setActiveChart(pType.target.value);
  // };
  // useEffect(() => {
  //   if (inputRef?.current != null) {
  //     inputRef?.current?.setFocus();
  //   }
  //   if (inputRefByYear?.current != null) {
  //     inputRefByYear?.current?.setFocus();
  //   }
  // }, [activeChart]);

  // const handleDownloadByYear = async (dateString: any): Promise<void> => {
  //   const date = new Date(dateString);
  //   const year = date.getFullYear();
  //   try {
  //     const response: any = await ApiUtils.downloadSalesReport(`year=${year}`);

  //     if (response?.data.report_file_url !== '') {
  //       toast.success(response.message);
  //       window.open(response.data.report_file_url, '_blank');
  //     } else {
  //       toast.error('Report not available');
  //     }

  //     setActiveChart('');
  //   } catch (error: any) {
  //     toast.error(error.message);
  //   }
  // };
  // const handleDownloadByMonth = async (dateString: any): Promise<void> => {
  //   const date = new Date(dateString);

  //   const month = date.getMonth() + 1;
  //   try {
  //     const response: any = await ApiUtils.downloadSalesReport(
  //       `month=${month}`,
  //     );
  //     // window.open(response.data.report_file_url, '_blank');
  //     if (response?.data.report_file_url !== '') {
  //       toast.success(response.message);
  //       window.open(response.data.report_file_url, '_blank');
  //     } else {
  //       toast.error('Report not available');
  //     }

  //     setActiveChart('');
  //   } catch (error: any) {
  //     toast.error(error.message);
  //   }
  // };
  return (
    <Col xxl={12} className="order-last">
      <Card>
        <Card.Header className="align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1 text-start">
            Demographics
          </h4>
          {/* <div className="d-flex align-items-center">
            <div className="input-group d-flex" data-testid="year-picker">
              <DatePicker
                selected={startDate}
                onChange={(date: any) => {
                  setStartDate(date);
                }}
                showYearPicker
                dateFormat="yyyy"
                className="form-control"
              />
              <div
                className="input-group-text bg-primary border-primary text-white  mx-2"
                style={{borderRadius: '0.15rem'}}>
                <i className="ri-calendar-2-line"></i>
              </div>
            </div>
          </div>
          <div className="d-flex gap-2 report-download">
            {activeChart === 'monthly' ? (
              <div className="date-and-month-picker">
                <DatePicker
                  ref={inputRef}
                  selected={startDate}
                  onChange={handleDownloadByMonth}
                  showMonthYearPicker
                  dateFormat="M"
                  className="form-control"
                />
              </div>
            ) : activeChart === 'year' ? (
              <div className="date-and-month-picker">
                <DatePicker
                  ref={inputRefByYear}
                  selected={startDate}
                  onChange={handleDownloadByYear}
                  showYearPicker
                  dateFormat="yyyy"
                  className="form-control"
                />
              </div>
            ) : (
              ''
            )}
          </div> */}
        </Card.Header>
        <Card.Body>
          <Row>
            <Col xxl={6} style={{borderRight: '1px solid #c2c2c2'}}>
              <Chart
                options={optionsGenderBased}
                series={
                  dashBoardCount !== undefined
                    ? [dashBoardCount?.male, dashBoardCount?.female]
                    : []
                }
                type="donut"
                height="440"
                className="apex-charts apex-charts-dashboard1"
              />
            </Col>

            <Col xxl={6}>
              <Chart
                options={optionsMemberBased}
                series={
                  dashBoardCount !== undefined
                    ? [dashBoardCount?.member, dashBoardCount?.non_member]
                    : []
                }
                type="donut"
                height="440"
                className="apex-charts apex-charts-dashboard1"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default ReportUserAnalyticsDemographics;
